import { render, staticRenderFns } from "./productPriceSerach-import.vue?vue&type=template&id=4af11aa1&scoped=true&"
import script from "./productPriceSerach-import.vue?vue&type=script&lang=js&"
export * from "./productPriceSerach-import.vue?vue&type=script&lang=js&"
import style0 from "./productPriceSerach-import.vue?vue&type=style&index=0&id=4af11aa1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af11aa1",
  null
  
)

export default component.exports